module.exports = __webpack_public_path__ + "img/symbol_3.9ea45a24.png";